<template>
    <div
        class="flex flex-wrap items-center justify-center gap-y-2"
        :class="
            isDesktop
                ? 'overflow-visible px-0'
                : 'overflow-x-auto overscroll-x-contain px-2'
        "
    >
        <component
            :is="item.href ? 'a' : 'div'"
            v-for="item in items"
            :key="item.key"
            v-bind="linkAttrs(item)"
            :aria-label="item.title"
            class="relative flex flex-shrink-0 overflow-hidden rounded-xl bg-stack-text shadow-lg no-underline"
            :class="isDesktop ? 'mx-4 my-4 h-56 w-72' : 'mx-1.5 my-2 h-40 w-52'"
            @click="onClick"
        >
            <img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                :alt="item.imageAlt"
                class="absolute inset-0 h-full w-full object-cover"
            />
            <div v-else class="absolute inset-0">
                <slot name="placeholder" :item="item"></slot>
            </div>
        </component>
    </div>
</template>

<script>
export default {
    name: "SliderV5",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    methods: {
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
